import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  po_id: yup.string().required("PO number is required"),
  // invoice_date: yup.string().required("Invoice date is required"),
  // invoice_due_date: yup.string().required("Invoice due date is required"),
  items: yup.array().of(
    yup.object().shape({
      bill_quantity: yup.string().required("Quantity is required"),
    }),
  ),
});

export const useValidation = ({ ...params }) => {
  return useForm({
    resolver: yupResolver(schema),
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      ...params,
    },
  });
};
